// SEO-landingspagina's voor fitnessapparatuur verhuizen (servicegebied: heel Nederland)
// Elke pagina: unieke content, secties (H2), bullets, tabel/stappen, FAQ's en interne links.

export const landingPages = [
  {
    slug: 'fitnessapparatuur-verhuizen',
    keyword: 'fitnessapparatuur verhuizen',
    metaTitle: 'Fitnessapparatuur verhuizen in heel Nederland | Nexon',
    metaDescription:
      'Fitnessapparatuur verhuizen door specialisten. Veilig demonteren, transporteren en monteren van Technogym, loopbanden en krachtstations. 5+ jaar ervaring, heel Nederland. Vraag een gratis offerte aan.',
    h1: 'Fitnessapparatuur verhuizen',
    badge: 'Specialist fitness verhuizen',
    intro: [
      'Fitnessapparatuur verhuizen is specialistenwerk. Cardio- en krachttoestellen zijn zwaar, kwetsbaar en vaak kostbaar. Eén verkeerde greep en u beschadigt een frame, een display of de vloer. Nexon Installatie & Service verhuist fitnessapparatuur veilig en vakkundig door heel Nederland, voor sportscholen, hotels, bedrijven en particulieren.',
      'Wij regelen het complete traject: van demontage en professionele verpakking tot transport, plaatsing en hermontage op de nieuwe locatie. Met meer dan 5 jaar ervaring en kennis van merken zoals Technogym, Life Fitness, Matrix en Precor weten wij precies hoe elk toestel veilig verplaatst moet worden.',
    ],
    sections: [
      {
        h2: 'Waarom fitnessapparatuur verhuizen door een specialist?',
        paras: [
          'Een loopband, krachtstation of multigym is geen gewoon meubelstuk. Het gewicht kan oplopen tot honderden kilo\u2019s, het zwaartepunt ligt vaak ongunstig en elektronica is gevoelig voor schokken. Een reguliere verhuizer mist meestal het gereedschap en de kennis om dit veilig te doen.',
          'Wij werken met de juiste hulpmiddelen (steekwagens, hef- en sjorbanden, trapklimmers) en kennen de demontagevoorschriften per merk. Zo voorkomen we schade aan uw apparatuur, de vloer en de omgeving.',
        ],
        bullets: [
          'Vakkundige demontage volgens fabrieksvoorschriften',
          'Professioneel verpakkings- en beschermmateriaal',
          'Geschikt materieel voor zware en kwetsbare toestellen',
          'Correcte hermontage en functionele controle',
        ],
      },
      {
        h2: 'Onze werkwijze: zo verhuizen wij uw fitnessapparatuur',
        paras: [
          'We werken volgens een vast, transparant stappenplan zodat u precies weet wat u kunt verwachten. Voor elke opdracht maken we vooraf een duidelijke offerte met prijs en planning.',
        ],
        bullets: [],
      },
      {
        h2: 'Welke fitnessapparatuur verhuizen wij?',
        paras: [
          'Wij verhuizen vrijwel alle soorten cardio- en krachtapparatuur, ongeacht het merk. Heeft u een complete sportschool of slechts één toestel? Beide kan.',
        ],
        bullets: [
          'Loopbanden, crosstrainers, hometrainers en roeitrainers',
          'Krachtstations, multigyms en kabelmachines',
          'Halterbanken, smith-machines en power racks',
          'Technogym-, Life Fitness-, Matrix- en Precor-apparatuur',
          'Complete gyms en sportscholen (B2B)',
          'Thuisgym-apparatuur voor particulieren (B2C)',
        ],
      },
    ],
    steps: [
      { title: 'Inventarisatie & offerte', text: 'U geeft door welke toestellen verhuisd moeten worden, met ophaal- en afleveradres. U ontvangt een vrijblijvende offerte met vaste prijs en planning.' },
      { title: 'Demontage & verpakking', text: 'Op de afgesproken dag demonteren wij de toestellen waar nodig en verpakken we alle onderdelen beschermd.' },
      { title: 'Veilig transport', text: 'Wij transporteren uw apparatuur gezekerd in onze voertuigen door heel Nederland.' },
      { title: 'Montage & controle', text: 'Op de nieuwe locatie monteren wij alles weer, stellen we de toestellen af en voeren we een functionele veiligheidscontrole uit.' },
    ],
    faqs: [
      { q: 'Wat kost het verhuizen van fitnessapparatuur?', a: 'De kosten hangen af van het type en aantal toestellen, of demontage nodig is, de afstand, de bereikbaarheid (trappen, lift) en de gewenste planning. Elke verhuizing is maatwerk. U ontvangt altijd een vrijblijvende offerte met een vaste prijs vooraf.' },
      { q: 'Moet mijn fitnessapparaat gedemonteerd worden voor de verhuizing?', a: 'Dat hangt af van het type toestel, het gewicht en de doorgangen op locatie. Zware krachtstations en multigyms worden bijna altijd (deels) gedemonteerd. Loopbanden en cardio kunnen vaak in één stuk verplaatst worden. Wij beoordelen dit vooraf en demonteren en monteren waar nodig.' },
      { q: 'Verhuizen jullie ook één los toestel?', a: 'Ja. Wij verhuizen zowel complete sportscholen als één enkel toestel voor particulieren. Of u nu één loopband of een hele gym wilt verplaatsen, wij helpen u graag.' },
      { q: 'In welk gebied verhuizen jullie fitnessapparatuur?', a: 'Wij zijn actief in heel Nederland. Van Amsterdam en Rotterdam tot Groningen en Maastricht: wij komen bij u langs voor het ophalen, transporteren en plaatsen van uw fitnessapparatuur.' },
    ],
    related: [
      { name: 'Technogym verhuizen', path: '/diensten/technogym-verhuizen' },
      { name: 'Loopband verhuizen', path: '/diensten/loopband-verhuizen' },
      { name: 'Krachtstation verhuizen', path: '/diensten/krachtstation-verhuizen' },
      { name: 'Fitnessapparatuur demonteren en monteren', path: '/diensten/fitnessapparatuur-demonteren-monteren' },
    ],
  },

  {
    slug: 'technogym-verhuizen',
    keyword: 'Technogym verhuizen',
    metaTitle: 'Technogym verhuizen & transport zonder schade | Nexon',
    metaDescription:
      'Technogym verhuizen en transporteren door specialisten. Veilig demonteren, vervoeren en monteren van Technogym cardio- en krachttoestellen in heel Nederland. Vraag een gratis offerte aan.',
    h1: 'Technogym verhuizen',
    badge: 'Technogym specialist',
    intro: [
      'Technogym-toestellen behoren tot de zwaarste en meest geavanceerde fitnessapparatuur ter wereld. Een Technogym Kinesis, Selection of Excite-toestel verhuizen vraagt om kennis, ervaring en het juiste materieel. Nexon Installatie & Service is gespecialiseerd in het verhuizen en transporteren van Technogym-apparatuur door heel Nederland.',
      'Wij weten hoe Technogym-toestellen veilig gedemonteerd, verpakt, vervoerd en weer gemonteerd worden, zodat de geavanceerde elektronica en de afwerking onbeschadigd blijven. Zo verhuist u uw Technogym zonder zorgen en zonder schade.',
    ],
    sections: [
      {
        h2: 'Waarom Technogym verhuizen specialistenwerk is',
        paras: [
          'Technogym-apparatuur combineert een zwaar, robuust frame met gevoelige touchscreens en elektronica. Het gewicht van een krachtstation of cardio-toestel kan flink oplopen, en de toestellen hebben vaak een ongunstig zwaartepunt. Verkeerd tillen leidt snel tot schade aan het toestel of letsel.',
          'Onze monteurs kennen de opbouw van Technogym-toestellen en demonteren alleen wat nodig is. Kabels, gewichtenpakketten en displays worden apart en beschermd verpakt en vervoerd.',
        ],
        bullets: [
          'Kennis van Technogym Selection, Excite, Kinesis en Pure',
          'Veilig loskoppelen van displays en elektronica',
          'Gewichtenpakketten apart vervoeren voor minder risico',
          'Hermontage en kalibratie/afstelling op de nieuwe locatie',
        ],
      },
      {
        h2: 'Hoe zwaar is een Technogym-toestel?',
        paras: [
          'Het gewicht verschilt sterk per toestel. Een cardio-toestel zoals een Technogym Excite loopband kan rond de 150\u2013200 kg wegen, terwijl een volledig krachtstation met gewichtenpakket nog veel zwaarder is. Daarom werken wij altijd met voldoende mankracht en professioneel hef- en transportmateriaal.',
        ],
        bullets: [],
      },
    ],
    steps: [
      { title: 'Beoordeling toestel', text: 'Wij bepalen welke Technogym-toestellen verhuisd worden en of (gedeeltelijke) demontage nodig is.' },
      { title: 'Veilige demontage', text: 'Displays, kabels en gewichten worden zorgvuldig losgekoppeld en apart verpakt.' },
      { title: 'Beschermd transport', text: 'Het frame en de onderdelen worden gezekerd vervoerd om schade te voorkomen.' },
      { title: 'Montage & test', text: 'Op locatie bouwen wij het toestel weer op, stellen het af en testen de werking.' },
    ],
    table: null,
    faqs: [
      { q: 'Wat kost het verhuizen van een Technogym toestel?', a: 'De prijs hangt af van het type Technogym-toestel, het gewicht, of demontage nodig is en de bereikbaarheid van beide locaties. Omdat Technogym-toestellen zwaar en kostbaar zijn, maken wij altijd een offerte op maat met een vaste prijs vooraf.' },
      { q: 'Hoe zwaar is een Technogym toestel?', a: 'Dat verschilt per model. Cardio-toestellen zoals de Excite-lijn wegen vaak 150\u2013200 kg, terwijl krachtstations met gewichtenpakket aanzienlijk zwaarder kunnen zijn. Wij stemmen mankracht en materieel hierop af.' },
      { q: 'Kan een Technogym toestel zonder schade verhuisd worden?', a: 'Ja, mits het vakkundig gebeurt. Wij demonteren waar nodig, verpakken displays en elektronica beschermd, vervoeren alles gezekerd en monteren het toestel weer correct. Zo blijft uw Technogym in topconditie.' },
      { q: 'Verhuizen jullie ook een complete Technogym sportschool?', a: 'Zeker. Wij verzorgen complete gymverhuizingen met Technogym-apparatuur, inclusief planning zodat uw sportschool zo kort mogelijk dicht hoeft.' },
    ],
    related: [
      { name: 'Fitnessapparatuur verhuizen', path: '/diensten/fitnessapparatuur-verhuizen' },
      { name: 'Krachtstation verhuizen', path: '/diensten/krachtstation-verhuizen' },
      { name: 'Fitness transport', path: '/diensten/fitness-transport' },
      { name: 'Demonteren en monteren', path: '/diensten/fitnessapparatuur-demonteren-monteren' },
    ],
  },

  {
    slug: 'loopband-verhuizen',
    keyword: 'loopband verhuizen',
    metaTitle: 'Loopband verhuizen zonder schade in heel Nederland | Nexon',
    metaDescription:
      'Loopband verhuizen door specialisten. Veilig tillen, transporteren en plaatsen van uw loopband, ook naar een hogere verdieping. Heel Nederland, vaste prijs. Vraag een offerte aan.',
    h1: 'Loopband verhuizen',
    badge: 'Loopband specialist',
    intro: [
      'Een loopband verhuizen lijkt eenvoudig, maar de praktijk is anders. Loopbanden zijn zwaar (vaak 80 tot 150 kg), log van vorm en hebben een gevoelige motor en elektronica. Zonder de juiste aanpak beschadigt u snel het display, het loopdek of de vloer. Nexon verhuist uw loopband veilig door heel Nederland.',
      'Of het nu gaat om één loopband uit uw thuisgym of meerdere toestellen voor een sportschool: wij tillen, transporteren en plaatsen uw loopband vakkundig, ook als die naar een hogere verdieping moet.',
    ],
    sections: [
      {
        h2: 'Loopband verhuizen zonder schade: waar let u op?',
        paras: [
          'Loopbanden hebben een hoog gewicht op een klein oppervlak en een kwetsbare elektronica- en motorunit. Schuiven over de vloer of verkeerd tillen leidt tot beschadigingen. Veel moderne loopbanden zijn opklapbaar, wat het transport makkelijker maakt, maar de vergrendeling moet correct gezekerd worden.',
        ],
        bullets: [
          'Loopdek en motorkap beschermen tegen stoten',
          'Opklapmechanisme correct vergrendelen voor transport',
          'Met voldoende mankracht tillen, niet schuiven',
          'Trapklim-materieel bij verhuizing naar een verdieping',
        ],
      },
      {
        h2: 'Loopband naar een hogere verdieping verhuizen',
        paras: [
          'Een loopband naar boven of beneden verplaatsen via een trap is risicovol vanwege het gewicht en de afmetingen. Wij gebruiken hiervoor de juiste hulpmiddelen en voldoende mankracht. In sommige gevallen adviseren wij een verhuislift. Geef bij uw aanvraag door op welke verdieping de loopband staat of moet komen, en of er een lift aanwezig is.',
        ],
        bullets: [],
      },
    ],
    steps: [
      { title: 'Aanvraag', text: 'Geef merk/type loopband door, plus de verdieping en bereikbaarheid op beide adressen.' },
      { title: 'Voorbereiding', text: 'Wij klappen de loopband veilig in (indien mogelijk) en beschermen kwetsbare delen.' },
      { title: 'Transport', text: 'De loopband wordt gezekerd vervoerd naar het nieuwe adres.' },
      { title: 'Plaatsing', text: 'Wij zetten de loopband op de gewenste plek en controleren de werking.' },
    ],
    table: null,
    faqs: [
      { q: 'Hoe verhuis je een loopband?', a: 'Een loopband verhuist u door deze (indien mogelijk) in te klappen en te vergrendelen, kwetsbare delen te beschermen, met voldoende mankracht te tillen en gezekerd te vervoeren. Schuiven over de vloer en verkeerd tillen moet u vermijden. Wij verzorgen dit volledig voor u.' },
      { q: 'Kan een loopband naar een hogere verdieping verhuisd worden?', a: 'Ja. Met de juiste hulpmiddelen en voldoende mankracht verplaatsen wij loopbanden ook naar hogere verdiepingen. Bij zeer zware toestellen of smalle trappen adviseren we eventueel een verhuislift. Geef de verdieping door bij uw aanvraag.' },
      { q: 'Hoe zwaar is een loopband?', a: 'Een loopband weegt doorgaans tussen de 80 en 150 kg, afhankelijk van het model. Professionele sportschoolloopbanden kunnen zwaarder zijn. Daarom verplaatsen wij ze altijd met de juiste techniek en mankracht.' },
      { q: 'Moet een loopband gedemonteerd worden?', a: 'Meestal niet volledig. Veel loopbanden zijn opklapbaar en kunnen in één stuk verplaatst worden. Soms verwijderen we de armleuningen of het display voor een veilige doorgang. Wij beoordelen dit ter plaatse.' },
    ],
    related: [
      { name: 'Fitnessapparatuur verhuizen', path: '/diensten/fitnessapparatuur-verhuizen' },
      { name: 'Crosstrainer verhuizen', path: '/diensten/crosstrainer-verhuizen' },
      { name: 'Fitness transport', path: '/diensten/fitness-transport' },
    ],
  },

  {
    slug: 'crosstrainer-verhuizen',
    keyword: 'crosstrainer verhuizen',
    metaTitle: 'Crosstrainer verhuizen veilig & snel | Nexon',
    metaDescription:
      'Crosstrainer verhuizen door specialisten. Veilig demonteren, transporteren en plaatsen van uw crosstrainer of hometrainer in heel Nederland. Vraag een vrijblijvende offerte aan.',
    h1: 'Crosstrainer verhuizen',
    badge: 'Cardio specialist',
    intro: [
      'Een crosstrainer verhuizen vraagt om aandacht voor de bewegende delen, het vliegwiel en de elektronica. Crosstrainers zijn zwaar aan de onderkant en log van vorm, waardoor ze lastig door deuren en trappen te manoeuvreren zijn. Nexon verhuist uw crosstrainer veilig en snel door heel Nederland.',
      'Wij demonteren waar nodig de stijlen, pedalen en het display, zodat het toestel veilig de deur uit kan en zonder schade op de nieuwe locatie weer in elkaar gezet wordt.',
    ],
    sections: [
      {
        h2: 'Waar let u op bij het verhuizen van een crosstrainer?',
        paras: [
          'Het zwaartepunt van een crosstrainer ligt laag en het vliegwiel is zwaar. De bewegende armen en pedalen kunnen beschadigen als ze niet worden vastgezet of gedemonteerd. Door de juiste delen los te nemen wordt het toestel compacter en veiliger te transporteren.',
        ],
        bullets: [
          'Bewegende armen en pedalen vastzetten of demonteren',
          'Display en console beschermd verpakken',
          'Vliegwiel en frame gezekerd vervoeren',
          'Correcte hermontage en testbeweging na plaatsing',
        ],
      },
    ],
    steps: [
      { title: 'Aanvraag & beoordeling', text: 'Geef merk/type crosstrainer door en de bereikbaarheid van beide adressen.' },
      { title: 'Demontage waar nodig', text: 'Wij nemen stijlen, pedalen en display los voor een veilige doorgang.' },
      { title: 'Transport', text: 'Alle onderdelen worden beschermd en gezekerd vervoerd.' },
      { title: 'Montage', text: 'Op locatie bouwen wij de crosstrainer weer op en controleren we de beweging.' },
    ],
    table: null,
    faqs: [
      { q: 'Moet een crosstrainer gedemonteerd worden om te verhuizen?', a: 'Vaak nemen wij de bewegende armen, pedalen en het display los, zodat het toestel compacter en veiliger te verplaatsen is. Of volledige demontage nodig is, hangt af van het model en de doorgangen op locatie.' },
      { q: 'Hoe zwaar is een crosstrainer?', a: 'Een crosstrainer weegt afhankelijk van het model doorgaans tussen de 50 en 120 kg. Het zware vliegwiel onderin maakt het toestel onhandig om te tillen, daarom doen wij dit met de juiste techniek.' },
      { q: 'Verhuizen jullie ook hometrainers en spinningbikes?', a: 'Ja, naast crosstrainers verhuizen wij ook hometrainers, spinningbikes en roeitrainers. Neem contact op voor een offerte op maat.' },
    ],
    related: [
      { name: 'Loopband verhuizen', path: '/diensten/loopband-verhuizen' },
      { name: 'Fitnessapparatuur verhuizen', path: '/diensten/fitnessapparatuur-verhuizen' },
      { name: 'Fitness transport', path: '/diensten/fitness-transport' },
    ],
  },

  {
    slug: 'krachtstation-verhuizen',
    keyword: 'krachtstation verhuizen',
    metaTitle: 'Krachtstation verhuizen & multigym transport | Nexon',
    metaDescription:
      'Krachtstation verhuizen door specialisten. Veilig demonteren, transporteren en monteren van krachtstations, multigyms en kabelmachines in heel Nederland. Vraag een offerte aan.',
    h1: 'Krachtstation verhuizen',
    badge: 'Kracht specialist',
    intro: [
      'Een krachtstation of multigym verhuizen is een van de zwaarste klussen binnen fitnessverhuizingen. Het gewichtenpakket alleen al weegt tientallen tot honderden kilo\u2019s, en het frame is groot en onhandig. Nexon verhuist krachtstations vakkundig en veilig door heel Nederland.',
      'Wij demonteren het gewichtenpakket, de kabels en de armen, vervoeren alles gezekerd en monteren het krachtstation op de nieuwe locatie weer correct en veilig.',
    ],
    sections: [
      {
        h2: 'Krachtstation veilig demonteren en monteren',
        paras: [
          'Een krachtstation bestaat uit een zwaar frame, een gewichtenpakket en een kabel- en katrolsysteem. Voor een veilige verhuizing nemen wij het gewichtenpakket apart en demonteren we kabels en armen. Bij de hermontage stellen we de kabels correct af en controleren we de werking en veiligheid.',
        ],
        bullets: [
          'Gewichtenpakket apart demonteren en vervoeren',
          'Kabels en katrollen gelabeld losnemen',
          'Frame gezekerd transporteren',
          'Correcte afstelling en veiligheidscontrole bij montage',
        ],
      },
    ],
    steps: [
      { title: 'Inventarisatie', text: 'Wij bepalen het type krachtstation/multigym en de benodigde demontage.' },
      { title: 'Demontage', text: 'Gewichten, kabels en armen worden gelabeld en beschermd losgenomen.' },
      { title: 'Transport', text: 'Frame en onderdelen worden zwaar materieel en gezekerd vervoerd.' },
      { title: 'Montage & controle', text: 'Op locatie bouwen wij alles weer op, stellen de kabels af en testen de veiligheid.' },
    ],
    table: null,
    faqs: [
      { q: 'Hoe verhuis je een krachtstation?', a: 'Een krachtstation verhuist u door eerst het gewichtenpakket en de kabels te demonteren, het frame gezekerd te vervoeren en alles op de nieuwe locatie weer correct te monteren en af te stellen. Vanwege het hoge gewicht is dit echt specialistenwerk dat wij volledig voor u verzorgen.' },
      { q: 'Moet een multigym altijd gedemonteerd worden?', a: 'In vrijwel alle gevallen wel. Het gewichtenpakket en de afmetingen maken het onmogelijk om een multigym in één stuk veilig te verplaatsen. Wij demonteren en monteren het toestel vakkundig.' },
      { q: 'Stellen jullie de kabels na montage weer goed af?', a: 'Ja. Na de hermontage stellen wij de kabels en katrollen correct af en voeren we een veiligheidscontrole uit, zodat u het krachtstation direct veilig kunt gebruiken.' },
    ],
    related: [
      { name: 'Technogym verhuizen', path: '/diensten/technogym-verhuizen' },
      { name: 'Fitnessapparatuur verhuizen', path: '/diensten/fitnessapparatuur-verhuizen' },
      { name: 'Demonteren en monteren', path: '/diensten/fitnessapparatuur-demonteren-monteren' },
    ],
  },

  {
    slug: 'fitness-transport',
    keyword: 'fitness transport',
    metaTitle: 'Fitness transport & fitnessapparatuur vervoeren | Nexon',
    metaDescription:
      'Professioneel fitness transport in heel Nederland. Veilig vervoer van fitnessapparatuur, ophalen bij leverancier en bezorgen op locatie. Vraag een vrijblijvende offerte aan.',
    h1: 'Fitness transport',
    badge: 'Transport specialist',
    intro: [
      'Professioneel fitness transport vraagt om voertuigen en kennis die zijn afgestemd op zware en kwetsbare apparatuur. Nexon verzorgt het transport van fitnessapparatuur door heel Nederland, of u nu nieuwe toestellen laat bezorgen, apparatuur ophaalt bij een leverancier of een complete gym verplaatst.',
      'Wij halen op, zekeren en bezorgen uw fitnessapparatuur op locatie, inclusief plaatsing in de juiste ruimte. Zo blijft uw apparatuur tijdens het transport optimaal beschermd.',
    ],
    sections: [
      {
        h2: 'Wat houdt professioneel fitness transport in?',
        paras: [
          'Fitnessapparatuur is zwaar, groot en gevoelig. Tijdens transport is goede zekering essentieel om schuiven, stoten en krassen te voorkomen. Wij gebruiken sjorbanden, dekens en het juiste materieel om uw apparatuur veilig van A naar B te brengen.',
        ],
        bullets: [
          'Ophalen bij leverancier, fabrikant of particulier',
          'Veilig gezekerd vervoer door heel Nederland',
          'Bezorging en plaatsing in de juiste ruimte',
          'Mogelijkheid tot combineren met (de)montage',
        ],
      },
    ],
    steps: [
      { title: 'Aanvraag', text: 'Geef ophaal- en afleveradres door, plus wat er vervoerd moet worden.' },
      { title: 'Ophalen', text: 'Wij halen de apparatuur op en zekeren deze in onze voertuigen.' },
      { title: 'Transport', text: 'Veilig vervoer naar de gewenste locatie.' },
      { title: 'Bezorging', text: 'Wij plaatsen de apparatuur op de juiste plek en kunnen direct (de)monteren.' },
    ],
    table: null,
    faqs: [
      { q: 'Is het transport van fitnessapparatuur verzekerd?', a: 'Wij werken zorgvuldig en met de juiste zekering om schade te voorkomen. Voor de exacte verzekeringsvoorwaarden van uw opdracht informeren wij u graag vooraf, zodat u precies weet waar u aan toe bent.' },
      { q: 'Kunnen jullie apparatuur ophalen bij een leverancier?', a: 'Ja. Wij halen uw fitnessapparatuur op bij de leverancier, fabrikant of een particulier en bezorgen het op uw locatie, inclusief plaatsing in de juiste ruimte.' },
      { q: 'Vervoeren jullie ook één enkel toestel?', a: 'Zeker. Of het nu om één toestel of een complete gym gaat, wij verzorgen het transport door heel Nederland.' },
    ],
    related: [
      { name: 'Fitnessapparatuur verhuizen', path: '/diensten/fitnessapparatuur-verhuizen' },
      { name: 'Technogym verhuizen', path: '/diensten/technogym-verhuizen' },
      { name: 'Loopband verhuizen', path: '/diensten/loopband-verhuizen' },
    ],
  },

  {
    slug: 'fitnessapparatuur-demonteren-monteren',
    keyword: 'fitnessapparatuur demonteren en monteren',
    metaTitle: 'Fitnessapparatuur demonteren en monteren | Nexon',
    metaDescription:
      'Fitnessapparatuur demonteren en monteren door specialisten. Veilig (de)monteren van krachtstations, cardio en complete gyms in heel Nederland. Vraag een offerte aan.',
    h1: 'Fitnessapparatuur demonteren en monteren',
    badge: 'Montage specialist',
    intro: [
      'Het demonteren en monteren van fitnessapparatuur is cruciaal voor een veilige verhuizing en een correct werkend toestel. Verkeerde (de)montage leidt tot schade of zelfs onveilige situaties. Nexon demonteert en monteert fitnessapparatuur vakkundig volgens fabrieksvoorschriften, in heel Nederland.',
      'Of u nu een nieuw toestel laat opbouwen, een gym laat inrichten of apparatuur wilt verplaatsen: wij zorgen dat alles veilig uit elkaar gaat en weer correct in elkaar gezet wordt.',
    ],
    sections: [
      {
        h2: 'Vakkundige (de)montage volgens fabrieksvoorschriften',
        paras: [
          'Elk merk en model heeft eigen demontage- en montagevoorschriften. Onze monteurs labelen onderdelen, bewaren bevestigingsmateriaal geordend en monteren toestellen volgens de specificaties van de fabrikant. Na montage volgt altijd een afstelling en veiligheidscontrole.',
        ],
        bullets: [
          'Onderdelen labelen en bevestigingsmateriaal ordenen',
          'Montage volgens fabrieksvoorschriften',
          'Afstelling van kabels, gewichten en displays',
          'Veiligheidscontrole en functionele test',
        ],
      },
    ],
    steps: [
      { title: 'Beoordeling', text: 'Wij bepalen welke toestellen (de)gemonteerd moeten worden.' },
      { title: 'Demontage', text: 'Toestellen worden geordend en beschermd gedemonteerd.' },
      { title: 'Montage', text: 'Op de gewenste locatie monteren wij alles volgens voorschrift.' },
      { title: 'Controle', text: 'Afstelling, veiligheidscheck en functionele test.' },
    ],
    table: null,
    faqs: [
      { q: 'Demonteren en monteren jullie alle merken fitnessapparatuur?', a: 'Ja, wij werken met vrijwel alle merken, waaronder Technogym, Life Fitness, Matrix en Precor. Onze monteurs kennen de fabrieksvoorschriften per merk en model.' },
      { q: 'Kan ik alleen de montage laten doen, zonder transport?', a: 'Zeker. U kunt bij ons terecht voor alleen demontage, alleen montage, of het complete verhuistraject inclusief transport. U bepaalt wat u nodig heeft.' },
      { q: 'Controleren jullie de veiligheid na de montage?', a: 'Altijd. Na de montage stellen wij het toestel af en voeren we een veiligheids- en functiecontrole uit, zodat u het direct en veilig kunt gebruiken.' },
    ],
    related: [
      { name: 'Krachtstation verhuizen', path: '/diensten/krachtstation-verhuizen' },
      { name: 'Technogym verhuizen', path: '/diensten/technogym-verhuizen' },
      { name: 'Fitnessapparatuur verhuizen', path: '/diensten/fitnessapparatuur-verhuizen' },
    ],
  },
];

export const getLandingPage = (slug) => landingPages.find((p) => p.slug === slug);
